import React, { useState } from "react";
import featureDetails from "./Feature_details.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileInvoiceDollar,
    faCalculator,
    faShieldAlt,
    faCogs,
    faFileInvoice,
    faUniversity,
    faBoxes,
    faChartBar,
    faBalanceScale,
    faNetworkWired,
    faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import "./Features.css";

const features = [
    { icon: faFileInvoiceDollar, label: "Invoicing" },
    { icon: faCalculator, label: "Accounting" },
    { icon: faShieldAlt, label: "Security" },
    { icon: faCogs, label: "Business Operation" },
    { icon: faFileInvoice, label: "E-Invoicing" },
    { icon: faUniversity, label: "Banking" },
    { icon: faBoxes, label: "Inventory" },
    { icon: faChartBar, label: "Reports" },
    { icon: faBalanceScale, label: "GST" },
    { icon: faNetworkWired, label: "Connected Service" },
    { icon: faMoneyBillWave, label: "Cash Flow" },
];

const cardColors = [
    "#007bff", "#ff7e5f", "#6a82fb", "#00c9a7", "#ffa41b", "#ff4b5c", "#6f42c1",
    "#00b894", "#fd79a8", "#e17055", "#0984e3", "#fab1a0", "#a29bfe", "#55efc4", "#fdcb6e",
    "#ff6b6b", "#1dd1a1", "#576574", "#5f27cd", "#feca57", "#ff9ff3", "#48dbfb", "#c8d6e5",
    "#2e86de", "#f368e0", "#10ac84", "#ff9f43", "#341f97", "#ee5253"
];

const Features = () => {
    const [activeFeature, setActiveFeature] = useState("Invoicing");

    return (
        <div className="features-page">
            {/* Hero Section */}
            <header className="features-hero">
                <h1 className="hero-title">Powerful Tools for Your Business</h1>
                <p className="hero-subtitle">
                    Explore a wide range of features built to simplify, automate, and grow your business operations.
                </p>
            </header>

            {/* Horizontal Tabs */}
            <div className="feature-tabs-scroll">
                {features.map((feature, idx) => (
                    <div
                        key={idx}
                        className={`tab-item ${activeFeature === feature.label ? "active" : ""}`}
                        onClick={() => setActiveFeature(feature.label)}
                    >
                        <FontAwesomeIcon icon={feature.icon} className="tab-icon" />
                        <span>{feature.label}</span>
                    </div>
                ))}
            </div>

            {/* Details Section */}
            <section className="feature-section">
                <h2 className="section-title">{activeFeature}</h2>
                <div className="feature-grid">
                    {featureDetails[activeFeature]?.map((item, i) => {
                        const color = cardColors[i % cardColors.length];
                        return (
                            <div
                                key={i}
                                className="feature-card-new"
                                style={{ borderTop: `5px solid ${color}` }}
                            >
                                <h3 className="card-title" style={{ color }}>{item.title}</h3>
                                <ul className="card-points">
                                    {item.description.map((desc, idx) => (
                                        <li key={idx}>{desc}</li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    );
};

export default Features;